import styled from 'styled-components';
import { color } from 'styles/pallete';

export const container = styled.div<{ $isShow: boolean }>`
	width: 100%;
	display: ${(props) => (props.$isShow ? 'flex' : 'none')};
	flex-direction: column;
	gap: 1.5rem;
	height: 100%;
	overflow: auto;
`;

export const twoInputs = styled.div`
	width: 100%;
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 1.5rem;

	@media (max-width: 1000px) {
		grid-template-columns: 1fr;
	}
`;

export const threeInputs = styled.div`
	width: 100%;
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
	gap: 1.5rem;

	@media (max-width: 1000px) {
		grid-template-columns: 1fr;
	}
`;

export const title = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: flex-start;

	> p {
		color: ${color.interface.lightGray};
		font-size: 1.5rem;
		font-weight: 900;
	}
`;

export const line = styled.div`
	width: 100%;
	min-height: 1px;
	background-color: ${color.interface.lightGray2};
`;
